import { all, call, put, takeLeading, select } from "redux-saga/effects"
import { actions, types } from '@src/store';
import { selectCoursePage, selectStoriesPage, selectLanguage } from '@src/store/selectors';
import { fetchContents } from "@src/apis/Contents";

const logger = Logger.get('contents/saga');

function* ContentsSaga() {
 yield all([
     takeLeading( types.course.GetCourses, getCourseList ),
     takeLeading( types.stories.GetStories, getStoriesList )
 ]);
}

function* getCourseList( { payload } ) {
  
  try{
    yield put( actions.common.SetLoader( true ) ) ;

    const { profile } = payload ;

    const language = yield select( selectLanguage );
    const preferredlanguage = language;


    const uniqueId = `${ profile.profileid }/${ profile.currentLevel }/${ language }` ;

    yield put( actions.course.SetIdentifier( { uniqueId } ) );

    const page = yield select( selectCoursePage );
    
    const contenttype = 'COURSE';
    let courses = yield call( fetchContents, { page, contenttype, level: profile?.currentLevel,preferredlanguage } );
    yield put(actions.course.AddCourses( { courses } ) );

    yield put( actions.common.SetLoader( false ) ) ;

    yield put( actions.firebase.GetDisabledCourses( { profile } ) );
    // yield put( actions.firebase.GetDisabledLevels( { profile } ) );
    yield put(actions.firebase.GetCourses({ profile }))
  }
  catch(err){
    logger.log( err );
    yield put( actions.common.SetLoader( false ) ) ;
  }
}

function* getStoriesList( { payload } ) {
  
  try{
    yield put( actions.common.SetLoader( true ) ) ;
    const { profile, seriesid } = payload ;

    const language = yield select( selectLanguage );

    const preferredlanguage = language;
    const uniqueId = `${ profile.profileid }/${ profile.currentLevel }/${ seriesid }/${ language }` ;

    yield put( actions.stories.SetIdentifier( { uniqueId } ) );

    const page = yield select( selectStoriesPage );
 
    const stories = yield call( fetchContents, { page, seriesid,preferredlanguage } );

    yield put(actions.stories.AddStories( { stories, seriesid } ) );
    yield put( actions.common.SetLoader( false ) ) ;

    yield put( actions.firebase.GetLessons( { profile, seriesid }) )
  }
  catch(err){
    logger.log( err );
    yield put( actions.common.SetLoader( false ) ) ;
  }
}

export default ContentsSaga;